module.exports = __webpack_public_path__ + "static/media/System_Alerts.e7ab0241.svg";